// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3W5zS","left":"styles_left__2bdXC"};